import { v4 as uuidv4 } from 'uuid';
import { fetchRecords, saveRecord, updateRecord, deleteRecords, openDB } from './indexedDB';
import { storeMapLogsInBE } from '../services/api/activityLog.api';

export class WebMapLogger {
  static instance = null;
  #traceId;
  #db;

  static getInstance() {
    if (WebMapLogger.instance == null)
      WebMapLogger.instance = new WebMapLogger();

    return this.instance;
  }

  async openDatabase() {
    if (!this.#db) this.#db = await openDB('map-logs', 'logger');
  }

  createLog(page_name) {
    const id = uuidv4();
    saveRecord(this.#db, 'logger', { id, page_name, startAt: Date.now() });
    this.#traceId = id;
  }

  updateLogEnd() {
    if (this.#traceId) updateRecord(this.#db, 'logger', this.#traceId, { endAt: Date.now() });
  }

  async logPageChange(page_name) {
    await this.openDatabase();
    if (page_name) {
      if (!this.#traceId) this.createLog(page_name);
      else {
        this.updateLogEnd();
        this.createLog(page_name);
      }
    } else {
      if (this.#traceId) {
        this.updateLogEnd();
        this.#traceId = undefined;
      }
    }
  }

  async scheduler() {
    await this.openDatabase();
    const records = await fetchRecords(this.#db, 'logger');
    if (records.length > 0) {
      storeMapLogsInBE(records);
      deleteRecords(this.#db, 'logger', records)
        .then(() => this.#traceId = undefined);
    }
  }
}

